<mat-card appearance="outlined">
  <mat-card-title class="title">
    <img
      [src]="systemTypeImageUrl()"
      [alt]="system().__typename"
      [matTooltip]="system().__typename"
      matTooltipPosition="below"
    />
    {{ system().modelName }}
  </mat-card-title>

  <mat-card-content class="content">
    <div class="image mr-16">
      @if (systemImageUrl()) {
      <img
        [src]="systemImageUrl()"
        (click)="openSystemImage()"
        alt="System image"
      />
      } @else {
      <div class="missing-image">No image</div>
      }

      <div class="manufacturers">
        <p class="text-medium-emphasis">Manufacturers</p>
        <div class="logos">
          @for (manufacturer of system().manufacturers; track manufacturer) {
          <mat-card appearance="outlined" class="logo">
            <mat-card-content>
              @if (manufacturer.logo.schematic) {
              <img
                [src]="manufacturer.logo.schematic?.url"
                [alt]="manufacturer.name"
                [matTooltip]="manufacturer.name"
                matTooltipPosition="below"
              />
              } @if (!manufacturer.logo.schematic) {
              <p>
                {{ manufacturer.name }}
              </p>
              }
            </mat-card-content>
          </mat-card>
          }
        </div>
      </div>
    </div>

    <div class="details">
      @if (boilerSystem()) {
      <div class="subsystems">
        <span class="text-medium-emphasis">Furnace</span>
        <app-system-thumbnail
          [system]="boilerSystem().furnace"
        ></app-system-thumbnail>
        <span class="text-medium-emphasis mt-4">Control Unit</span>
        <app-system-thumbnail
          [system]="boilerSystem().controlUnit"
        ></app-system-thumbnail>
      </div>
      } @else if (boilerControlWithFitsInSystem()) {
      <div class="subsystems">
        <span class="text-medium-emphasis">Boiler Control</span>
        <app-system-thumbnail
          [system]="boilerControlWithFitsInSystem().boilerControl"
        ></app-system-thumbnail>
        <span class="text-medium-emphasis mt-4">Fitted In System</span>
        <app-system-thumbnail
          [system]="boilerControlWithFitsInSystem().fitIn"
        ></app-system-thumbnail>
      </div>
      }
      <div>
        <span class="text-medium-emphasis">Verbose names</span><br />
        <span>{{ verboseNames() }}</span>
      </div>
      @if (heatingTypeInfoAvailable()) {
      <div class="mt-16">
        <span class="text-medium-emphasis">Heating Type</span><br />
        <span>{{ heatingType() }}</span>
      </div>
      <div class="mt-16">
        <span class="text-medium-emphasis">Heat Pump Type</span><br />
        <span>{{ heatPumpType() }}</span>
      </div>
      } @if (powerSupply()) {
      <div>
        <span class="text-medium-emphasis">Power Supply</span><br />
        <span>{{ powerSupply() }}</span>
      </div>
      } @if (fitInAvailability()) {
      <div>
        <span class="text-medium-emphasis">Fit In Availability</span><br />
        <span>{{ fitInAvailability() }}</span>
      </div>
      }
      <div>
        <span class="text-medium-emphasis">Customer Visible</span><br />
        <span>{{ this.system().customerVisible }}</span>
      </div>
    </div>
  </mat-card-content>
</mat-card>
